import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SnowPlowIcon(props) {
	return (
		<IconBase type="snow-plow" {...props}>
			<path d="M10 13.5L12.1667 7H15.5L18.5 11V14H19.5V12H20.5L22.5 19C20.8431 19 19.5 17.6569 19.5 16H18C18 17.6569 16.6569 19 15 19C13.3431 19 12 17.6569 12 16H8C8 17.6569 6.65685 19 5 19C3.34315 19 2 17.6569 2 16C2 14.3431 3.34315 13 5 13C5.20544 13 5.40606 13.0207 5.59989 13.06L10 13.5ZM5 14.5C4.17157 14.5 3.5 15.1716 3.5 16C3.5 16.8284 4.17157 17.5 5 17.5C5.82843 17.5 6.5 16.8284 6.5 16C6.5 15.1716 5.82843 14.5 5 14.5ZM13.5 16C13.5 16.8284 14.1716 17.5 15 17.5C15.8284 17.5 16.5 16.8284 16.5 16C16.5 15.1716 15.8284 14.5 15 14.5C14.1716 14.5 13.5 15.1716 13.5 16ZM14.75 8.5H13V11H16.625L14.75 8.5Z" />
			<path d="M11.6126 5.5H7.61512L1.5 7V11.75L9.3041 12.4254L11.6126 5.5Z" />
		</IconBase>
	);
}
SnowPlowIcon.propTypes = iconPropTypes;
